/* Client helpers for per-user context, multi-role routing & resume.
 * Backed by /api/me/context and /api/me/role. Additive — never mutates modules. */
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const getContext = async () => {
  try {
    const res = await fetch(`${API_URL}/api/me/context`, { credentials: "include" });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
};

/* Mark the role the user is entering / switching into. */
export const setRole = async (role) => {
  try {
    const res = await fetch(`${API_URL}/api/me/role`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ role }),
    });
    return res.ok ? await res.json() : null;
  } catch {
    return null;
  }
};

/* Resolve where a just-logged-in user should land.
 * Admins → /dashboard-new. EVERY other user (new AND returning/existing) first
 * lands on /new-user-landing so all users follow one unified journey. Existing
 * CEO/founder & CA-firm users then continue into their created portal from
 * /ipo-role-select (via "Enter my IPO workspace") without re-registering. */
export const resolveLanding = async (loginUser) => {
  if (loginUser?.is_admin) return "/dashboard-new";
  const ctx = await getContext();
  if (ctx?.is_admin) return "/dashboard-new";
  return "/home";
};

export const logout = async () => {
  try { await fetch(`${API_URL}/api/auth/logout`, { method: "POST", credentials: "include" }); } catch { /* ignore */ }
  try { localStorage.removeItem("session_token"); } catch { /* ignore */ }
  try { sessionStorage.removeItem("ipolabs_consent_acked"); } catch { /* ignore */ }
};
